export const chunkArr = (arr: Array<any>, size: number): Array<any> => {
  const chunked = [];
  for (let i = 0; i < arr.length; i += size) {
    const chunk = arr.slice(i, i + size);
    chunked.push(chunk);
  }
  return chunked;
};
